(() => {
  const $ = s => document.querySelector(s);
  const $$ = s => [...document.querySelectorAll(s)];
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const fmt = cents => {
    const f = (window.GM && GM.moneyFormat) || "${{amount}}";
    const num = (c, dec, th, dp) => {
      const [i, d] = (c / 100).toFixed(dec).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? dp + d : "");
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: num(cents, 2, ",", "."),
      amount_no_decimals: num(cents, 0, ",", "."),
      amount_with_comma_separator: num(cents, 2, ".", ","),
      amount_no_decimals_with_comma_separator: num(cents, 0, ".", ","),
      amount_with_apostrophe_separator: num(cents, 2, "'", "."),
      amount_no_decimals_with_space_separator: num(cents, 0, " ", ","),
      amount_with_space_separator: num(cents, 2, " ", ",")
    })[k] || num(cents, 2, ",", "."));
  };
  const fmtShort = cents => fmt(cents).replace(/[.,]00(?=\D*$)/, "");

  /* ---------- cart drawer (works on every page) ---------- */
  const drawer = $("#drawer"), scrim = $("#scrim");
  function openCart(on) {
    if (!drawer) return;
    drawer.classList.toggle("on", on); scrim.classList.toggle("on", on);
    drawer.setAttribute("aria-hidden", on ? "false" : "true");
    if (on) $("#closeCart").focus();
  }
  async function renderCart() {
    if (!drawer) return;
    const cart = await fetch(GM.routes.cart).then(r => r.json());
    $("#cartCount").textContent = cart.item_count;
    const lines = $("#lines");
    lines.innerHTML = !cart.items.length ? `<div class="empty">Your cart is empty.</div>` : cart.items.map(it => `
      <div class="line"><img src="${it.image ? it.image.replace(/(\.\w+)(\?|$)/, "_160x$1$2") : ""}" alt="">
        <div><b>${it.product_title}</b><small>${it.variant_title || ""}</small>
          <div class="qty">
            <button type="button" data-key="${it.key}" data-q="${it.quantity - 1}" aria-label="Remove one">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-key="${it.key}" data-q="${it.quantity + 1}" aria-label="Add one">+</button>
          </div></div>
        <span class="lp">${fmt(it.original_line_price)}</span></div>`).join("");
    lines.querySelectorAll("[data-key]").forEach(b => b.addEventListener("click", async () => {
      await fetch(GM.routes.cartChange, {method: "POST", headers: {"Content-Type": "application/json"}, body: JSON.stringify({id: b.dataset.key, quantity: +b.dataset.q})});
      renderCart();
    }));
    const disc = $("#cartDisc");
    const saved = cart.original_total_price - cart.total_price;
    const titles = (cart.cart_level_discount_applications || []).map(d => d.title).join(", ");
    disc.hidden = saved <= 0;
    disc.innerHTML = saved > 0 ? `<span>${titles || "Bundle discount"}</span><span>−${fmt(saved)}</span>` : "";
    $("#subtotal").textContent = fmt(cart.total_price);
    $("#checkout").classList.toggle("disabled", !cart.items.length);
  }
  if (drawer) {
    $("#openCart").addEventListener("click", e => { e.preventDefault(); renderCart(); openCart(true); });
    $("#closeCart").addEventListener("click", () => openCart(false));
    scrim.addEventListener("click", () => openCart(false));
    document.addEventListener("keydown", e => { if (e.key === "Escape") openCart(false); });
  }

  /* ---------- videos ---------- */
  function makeVideo(src, poster) {
    const v = document.createElement("video");
    Object.assign(v, {src, muted: true, loop: true, playsInline: true, autoplay: true, preload: "metadata"});
    if (poster) v.poster = poster;
    v.setAttribute("muted", ""); v.setAttribute("playsinline", "");
    return v;
  }
  function soundButton(v, host) {
    const b = document.createElement("button");
    b.className = "snd"; b.type = "button"; b.setAttribute("aria-label", "Turn sound on");
    b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M17 9l4 6M21 9l-4 6"/></svg>';
    b.addEventListener("click", e => {
      e.stopPropagation();
      $$("video").forEach(o => { if (o !== v) o.muted = true; });
      v.muted = !v.muted; v.play().catch(() => {});
      b.setAttribute("aria-label", v.muted ? "Turn sound on" : "Turn sound off");
    });
    host.appendChild(b);
  }
  $$(".hero-vid").forEach(fig => {
    if (!fig.dataset.video) return;
    const v = makeVideo(fig.dataset.video, fig.dataset.poster);
    fig.prepend(v); fig.classList.add("has-video"); soundButton(v, fig);
  });

  /* ---------- product landing ---------- */
  const dataEl = $("#gm-data");
  if (!dataEl) return;
  const D = JSON.parse(dataEl.textContent);
  /* bundle savings are set in the shop currency: convert them at the live rate,
     the same way Shopify converts the automatic discount at checkout */
  const rate = +((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1);
  if (D.offShop) [2, 3].forEach(q => {
    const off = Math.round(D.offShop[q] * rate);
    D.prices[q] = D.unit * q - off;
    const t = document.querySelector(`.ticket[data-qty="${q}"]`);
    if (t) {
      const sv = t.querySelector(".t-save"), bp = t.querySelector(".t-bundle");
      if (sv) sv.textContent = fmtShort(off);
      if (bp) bp.textContent = fmtShort(D.prices[q]);
    }
    if (q === 3) document.querySelectorAll(".gm-crew-save").forEach(e => { e.textContent = "Buy 3, save " + fmtShort(off); });
  });
  const FACES = D.faces, ORDER = D.order.filter(k => FACES[k]);
  const state = {face: ORDER[0], qty: 3, slots: ORDER.slice(0, 3), gmode: "photo"};
  while (state.slots.length < 3) state.slots.push(ORDER[state.slots.length % ORDER.length]);

  /* snow + mountains */
  function initSnow() {
    const canvas = $("#snow");
    if (!window.THREE || !canvas) return;
    let renderer;
    try { renderer = new THREE.WebGLRenderer({canvas, alpha: true, antialias: true}); } catch (e) { return; }
    renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0x08111f, 18, 70);
    const cam = new THREE.PerspectiveCamera(55, 1, 0.1, 200);
    cam.position.set(0, 3, 16);
    const ridge = (z, h, color, seed) => {
      const segs = 70, g = new THREE.PlaneGeometry(140, 30, segs, 1), p = g.attributes.position;
      for (let i = 0; i <= segs; i++) {
        const x = p.getX(i);
        p.setY(i, Math.abs(Math.sin(x * 0.09 + seed) * h) + Math.abs(Math.sin(x * 0.23 + seed * 2)) * h * 0.35 + Math.random() * 0.8 - 4);
      }
      for (let i = segs + 1; i < p.count; i++) p.setY(i, -30);
      const m = new THREE.Mesh(g, new THREE.MeshBasicMaterial({color}));
      m.position.set(0, -6, z); scene.add(m);
    };
    ridge(-40, 16, 0x13284a, 1.3); ridge(-26, 11, 0x0f2140, 4.1); ridge(-14, 6, 0x0b1830, 2.2);
    const N = innerWidth < 700 ? 900 : 2200, pos = new Float32Array(N * 3), vel = new Float32Array(N);
    for (let i = 0; i < N; i++) { pos[i*3] = (Math.random() - .5) * 60; pos[i*3+1] = Math.random() * 40 - 12; pos[i*3+2] = (Math.random() - .5) * 50 - 5; vel[i] = 0.02 + Math.random() * 0.05; }
    const sg = new THREE.BufferGeometry(); sg.setAttribute("position", new THREE.BufferAttribute(pos, 3));
    const dot = document.createElement("canvas"); dot.width = dot.height = 32;
    const c = dot.getContext("2d"), gr = c.createRadialGradient(16, 16, 0, 16, 16, 16);
    gr.addColorStop(0, "rgba(255,255,255,1)"); gr.addColorStop(1, "rgba(255,255,255,0)"); c.fillStyle = gr; c.fillRect(0, 0, 32, 32);
    scene.add(new THREE.Points(sg, new THREE.PointsMaterial({size: 0.28, map: new THREE.CanvasTexture(dot), transparent: true, depthWrite: false, opacity: .9})));
    let mx = 0, my = 0, t = 0, visible = true;
    addEventListener("pointermove", e => { mx = e.clientX / innerWidth - .5; my = e.clientY / innerHeight - .5; }, {passive: true});
    const resize = () => { const r = canvas.parentElement.getBoundingClientRect(); renderer.setSize(r.width, r.height, false); cam.aspect = r.width / r.height; cam.updateProjectionMatrix(); };
    resize(); addEventListener("resize", resize);
    new IntersectionObserver(([e]) => visible = e.isIntersecting).observe(canvas);
    const tick = () => {
      requestAnimationFrame(tick);
      if (!visible) return;
      t += 0.01;
      if (!reduce) { for (let i = 0; i < N; i++) { pos[i*3+1] -= vel[i]; pos[i*3] += Math.sin(t + i) * 0.01; if (pos[i*3+1] < -12) pos[i*3+1] = 28; } sg.attributes.position.needsUpdate = true; }
      cam.position.x += (mx * 3 - cam.position.x) * 0.04; cam.position.y += (3 - my * 2 - cam.position.y) * 0.04;
      cam.lookAt(0, 1, -10); renderer.render(scene, cam);
    };
    tick();
  }
  if (window.THREE) initSnow(); else addEventListener("load", initSnow);

  /* 3D face carousel */
  const ring = $("#ring"), stage = $("#stage3d"), frontNameEl = $("#frontName");
  const STEP = 360 / ORDER.length;
  ORDER.forEach(k => {
    const b = document.createElement("button");
    b.className = "m3d"; b.type = "button"; b.dataset.face = k; b.setAttribute("aria-label", "Choose " + FACES[k].name);
    b.innerHTML = `<img src="${FACES[k].img}" alt="${FACES[k].name} mask"><span class="nm">${FACES[k].name}</span>`;
    ring.appendChild(b);
  });
  const items = $$(".m3d");
  let angle = 0, target = 0, dragging = false, lastX = 0, moved = 0, idle = 0;
  function layout() {
    const w = stage.clientWidth;
    stage.style.setProperty("--mw", Math.min(210, Math.max(160, w * 0.42)) + "px");
    return Math.min(300, Math.max(140, w * 0.34));
  }
  let R = layout(); addEventListener("resize", () => { R = layout(); });
  function render() {
    items.forEach((el, i) => {
      const a = angle + i * STEP, z = Math.cos(a * Math.PI / 180);
      el.style.transform = `rotateY(${a}deg) translateZ(${R}px) rotateY(${-a}deg) scale(${0.72 + 0.28 * (z + 1) / 2})`;
      el.style.zIndex = Math.round((z + 1) * 50);
      el.style.opacity = 0.35 + 0.65 * (z + 1) / 2;
      el.querySelector("img").style.filter = `drop-shadow(0 30px 40px rgba(0,0,0,.55)) brightness(${0.55 + 0.45 * (z + 1) / 2})`;
    });
    const idx = ((Math.round(-angle / STEP) % ORDER.length) + ORDER.length) % ORDER.length;
    const nm = FACES[ORDER[idx]].name;
    if (frontNameEl.textContent !== nm) frontNameEl.textContent = nm;
  }
  (function loop() {
    if (!dragging) { idle++; if (idle > 180 && !reduce) { target -= STEP; idle = 0; } angle += (target - angle) * 0.08; }
    render(); requestAnimationFrame(loop);
  })();
  stage.addEventListener("pointerdown", e => { dragging = true; lastX = e.clientX; moved = 0; stage.setPointerCapture(e.pointerId); });
  stage.addEventListener("pointermove", e => { if (!dragging) return; const dx = e.clientX - lastX; lastX = e.clientX; moved += Math.abs(dx); angle += dx * 0.35; target = angle; });
  const endDrag = () => { if (!dragging) return; dragging = false; idle = 0; target = Math.round(angle / STEP) * STEP; };
  stage.addEventListener("pointerup", endDrag); stage.addEventListener("pointercancel", endDrag);
  items.forEach((el, i) => el.addEventListener("click", () => {
    if (moved > 6) return;
    idle = 0; const want = -i * STEP; target = want + Math.round((target - want) / 360) * 360;
    setFace(ORDER[i], true);
  }));
  $("#prev").addEventListener("click", () => { target += STEP; idle = 0; });
  $("#next").addEventListener("click", () => { target -= STEP; idle = 0; });

  /* tilt */
  function tilt(el, max, glare) {
    if (!el || reduce) return;
    el.addEventListener("pointermove", e => {
      const r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      el.style.transform = `perspective(900px) rotateY(${(x - .5) * max}deg) rotateX(${(.5 - y) * max}deg)`;
      if (glare) { el.style.setProperty("--gx", x * 100 + "%"); el.style.setProperty("--gy", y * 100 + "%"); }
    });
    el.addEventListener("pointerleave", () => { el.style.transform = ""; });
  }
  tilt($("#tilt"), 14); $$(".card").forEach(c => tilt(c, 10)); tilt($("#showcase"), 10, true);

  /* face picker */
  $("#faces").innerHTML = ORDER.map(k => `<button type="button" class="face" role="radio" aria-checked="false" data-face="${k}"><img src="${FACES[k].img}" alt=""><b>${FACES[k].name}</b></button>`).join("");

  function renderGallery() {
    const f = FACES[state.face], face = state.face;
    $("#tPhoto").src = f.img; $("#tVideo").src = f.img;
    $$(".thumbs button").forEach(b => b.setAttribute("aria-current", b.dataset.mode === state.gmode ? "true" : "false"));
    const img = $("#stageImg"), box = $("#gVid"), soon = $("#gSoon"), sc = $("#showcase");
    img.src = f.img; img.alt = f.name + " mask";
    $("#stageTag").textContent = state.gmode === "video" ? f.name + " · video" : f.name;
    box.hidden = true; box.innerHTML = ""; img.hidden = false; soon.hidden = true; sc.classList.remove("vmode");
    if (state.gmode !== "video") return;
    if (!f.video) { soon.hidden = false; return; }
    const v = makeVideo(f.video, f.poster);
    box.appendChild(v); soundButton(v, box); box.hidden = false; img.hidden = true; sc.classList.add("vmode");
  }
  $$(".thumbs button").forEach(b => b.addEventListener("click", () => { state.gmode = b.dataset.mode; renderGallery(); }));

  function setFace(face, scroll) {
    state.face = face; state.slots[0] = face;
    $$(".face").forEach(b => b.setAttribute("aria-checked", b.dataset.face === face ? "true" : "false"));
    $("#faceName").textContent = FACES[face].name;
    renderGallery(); renderSlots();
    if (scroll) $("#shop").scrollIntoView({behavior: reduce ? "auto" : "smooth"});
  }
  $$(".face").forEach(b => b.addEventListener("click", () => setFace(b.dataset.face)));
  $$(".pick").forEach(b => b.addEventListener("click", () => setFace(b.dataset.face, true)));

  /* bundles */
  function setQty(q) {
    state.qty = q;
    $$(".ticket").forEach(t => t.setAttribute("aria-checked", +t.dataset.qty === q ? "true" : "false"));
    const p = D.prices[q], full = D.unit * q;
    $("#price").textContent = fmt(p);
    $("#was").hidden = q === 1; $("#was").textContent = fmt(full);
    $("#save").hidden = q === 1; $("#save").textContent = "Save " + fmtShort(full - p);
    $("#per").textContent = (q === 1 ? "1 mask" : q + " masks") + " · " + fmt(Math.round(p / q)) + " each";
    $("#atcPrice").textContent = fmt(p);
    $("#stickyPrice").textContent = fmtShort(p);
    renderSlots();
  }
  $$(".ticket").forEach(t => t.addEventListener("click", () => setQty(+t.dataset.qty)));
  function renderSlots() {
    const box = $("#slots");
    if (state.qty === 1) { box.hidden = true; box.innerHTML = ""; return; }
    box.hidden = false;
    box.innerHTML = state.slots.slice(0, state.qty).map((f, i) => `
      <div class="slot"><label for="slot${i}">Mask ${i + 1}</label>
        <select id="slot${i}" data-i="${i}">${ORDER.map(k => `<option value="${k}"${k === f ? " selected" : ""}>${FACES[k].name}</option>`).join("")}</select></div>`).join("");
    box.querySelectorAll("select").forEach(s => s.addEventListener("change", e => {
      const i = +e.target.dataset.i; state.slots[i] = e.target.value;
      if (i === 0) setFace(e.target.value);
    }));
  }

  /* add to cart: one line per face, Shopify applies the bundle discount automatically */
  async function addToCart() {
    const err = $("#atcErr"); err.hidden = true;
    const counts = {};
    state.slots.slice(0, state.qty).forEach(k => { counts[k] = (counts[k] || 0) + 1; });
    const itemsToAdd = Object.entries(counts).map(([k, q]) => ({id: FACES[k].id, quantity: q}));
    [$("#atc"), $("#stickyAtc")].forEach(b => b.disabled = true);
    try {
      const r = await fetch(GM.routes.cartAdd, {method: "POST", headers: {"Content-Type": "application/json", "Accept": "application/json"}, body: JSON.stringify({items: itemsToAdd})});
      if (!r.ok) throw new Error((await r.json()).description || "Could not add to cart.");
      await renderCart(); openCart(true);
    } catch (e) {
      err.textContent = e.message + " Please try again."; err.hidden = false;
    } finally {
      [$("#atc"), $("#stickyAtc")].forEach(b => b.disabled = false);
    }
  }
  $("#atc").addEventListener("click", addToCart);
  $("#stickyAtc").addEventListener("click", addToCart);
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(([e]) => $("#stickyBuy").classList.toggle("on", !e.isIntersecting && e.boundingClientRect.top < 0)).observe($("#atc"));
  }

  setFace(state.face); setQty(3);
})();
